import { GetForm } from '@/data/getForm'

export const recaptchaEnabled = (form: GetForm) => {
  return form.settings.integrations.some((integration) => integration.enabled && integration.handle === 'recaptcha')
}
